import type { AdminSearchTerm, AdminSearchTermInput } from "./types";

export interface AdminSearchTermDraft {
  name: string;
  aliases: string;
  description: string;
}

export function searchTermDraft(entry?: AdminSearchTerm): AdminSearchTermDraft {
  return {
    name: entry?.name ?? "",
    aliases: entry?.aliases.join("\n") ?? "",
    description: entry?.description ?? "",
  };
}

function normalizedIdentity(value: string): string {
  return value.normalize("NFKC").replace(/\s+/gu, "").toLocaleLowerCase("zh-CN");
}

export function parseSearchTermDraft(
  draft: AdminSearchTermDraft,
  entries: AdminSearchTerm[],
  editingId?: string,
): { value?: AdminSearchTermInput; error?: string } {
  const name = draft.name.trim();
  const description = draft.description.trim();
  const aliases = [...new Set(draft.aliases.split(/[\n,，]/gu).map((value) => value.trim()).filter(Boolean))];
  if (!name) return { error: "请填写术语名称。" };
  if ([...name].length > 128) return { error: "术语名称不能超过 128 个字符。" };
  if (!description) return { error: "请填写术语说明。" };
  if ([...description].length > 4_000) return { error: "术语说明不能超过 4000 个字符。" };
  if (aliases.length > 32 || aliases.some((alias) => [...alias].length > 128)) return { error: "最多填写 32 个别名，每个不超过 128 个字符。" };

  const identities = [name, ...aliases].map(normalizedIdentity);
  if (new Set(identities).size !== identities.length) return { error: "名称和别名不能重复。" };
  const occupied = new Set(entries
    .filter((entry) => entry.id !== editingId)
    .flatMap((entry) => [entry.name, ...entry.aliases])
    .map(normalizedIdentity));
  if (identities.some((identity) => occupied.has(identity))) return { error: "名称或别名已被其他术语使用。" };
  return { value: { name, aliases, description } };
}
